module.exports = ".queue-template-form {\n  width: 300px; }\n\n.uploaded-image {\n  width: 150px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/addedit-queue-template/addedit-queue-template.component.scss
// module id = ./src/app/component/addedit-queue-template/addedit-queue-template.component.scss
// module chunks = main